<template>
  <div class="upload_box">
    <!-- 照片墙 -->
    <el-upload
      class="img_list_box"
      ref="imglist"
      action="http"
      list-type="picture-card"
      accept = '.jpg, .png, .jpeg'
      :multiple= 'true'
      :before-upload="beforeAvatarUpload"
      :http-request="imgListUpload"
      :limit="6"
      :on-exceed="exceedError"
      :before-remove="imgListBeforeRemove">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    list: { required: true }
  },
  data () {
    return {
      loading: false,
      imgListOnOff: false,
      imgList: [], // 照片列表
      dialogImageUrl: '',
      dialogVisible: false,
      uploadOnOff: false,
      removeOnOff: true,
      n: 0
    }
  },
  methods: {
    // 限制文件类型及大小
    beforeAvatarUpload (file) {
      let fileClass = false
      if (file.type === 'image/jpeg' || file.type === 'image/png') {
        fileClass = true
      }
      const fileSize = file.size / 1024 / 1024 < 3
      this.loading = true
      if (!fileClass) {
        this.$message.error('文件上传类型错误')
        return false
      }
      if (!fileSize) {
        this.$message.error('上传文件不大于3M')
        return false
      }
      this.uploadOnOff = fileClass && fileSize
      return this.uploadOnOff
    },
    // 文件上传接口
    async imgListUpload (param) {
      const vueThat = this
      if (vueThat.uploadOnOff) {
        const formData = new FormData()
        formData.append('image', param.file)
        try {
          await vueThat.myApi.boardImageUpload(formData).then((res) => {
            if (res.data.code === 200) {
              param.file.url = res.data.data.url
              vueThat.imgList.push(param.file)
              this.$emit('files', vueThat.imgList)
            }
          })
        } catch (e) {}
      }
    },
    // 文件超出上传个数接口
    exceedError () {
      this.$message.error('最多上传6张图片！')
    },
    // 照片删除
    imgListBeforeRemove (file) {
      const vueThat = this
      for (let i = 0; i < vueThat.imgList.length; i++) {
        if (file.uid === vueThat.imgList[i].uid) {
          vueThat.imgList.splice(i, 1)
          this.$emit('files', vueThat.imgList)
        }
      }
    },
    // 清空空图片列表
    clearImgList () {
      this.$refs.imglist.clearFiles()
    }
  }
}
</script>

<style>
  .img_list_box .el-upload--picture-card{
    background-color: #f7f7f7;
    border: 1px dashed #dadada;
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  .img_list_box .el-upload--picture-card:hover{
    border-color: #d7b76d
  }
  .img_list_box .el-upload--picture-card:hover i{
    color: #d7b76d
  }
  .img_list_box .el-upload--picture-card i{
    font-size: 20px;
  }
  .img_list_box .el-upload-list__item{
    width: 100px;
    height: 100px;
  }
</style>
